import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { makeAutoObservable, runInAction } from 'mobx';
import { ChatComment, ValueComment } from '../models/comment';
import { store } from './store';

export default class CommentStore {
  comments: ChatComment[] = [];
  hubConnection: HubConnection | null = null;
  token: string = '';
  constructor() {
    makeAutoObservable(this);
  }

  createHubConnection = (itemLevelId: string) => {
    let url = '';
    if (window.location.hostname === 'dev.vms-sandbox.com') {
      url = 'https://dev-api.vms-sandbox.com';
    } else if (window.location.hostname === 'preprod.vms-sandbox.com') {
      url = 'https://preprod-api.vms-sandbox.com';
    } else if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '172.16.0.138'
    ) {
      url = 'http://172.16.0.138:8080';
      // url = "https://prod-api.vms-sandbox.com/api";
    } else if (window.location.hostname === 'www.vms-sandbox.com') {
      url = 'https://vms-sandbox.com:3000';
    } else if (
      window.location.hostname === '192.168.100.72' ||
      window.location.hostname === '172.24.224.1'
    ) {
      url = 'https://192.168.100.72:5000';
    } else if (window.location.hostname === '172.16.0.118') {
      url = 'https://172.16.0.118:5000';
    } else {
      url = 'https://vms-sandbox.com:3000';
    }

    if (store.userStore.user?.token !== undefined) {
      this.token = store.userStore.user?.token;
    }
    if (store.activityStore.selectedActivity) {
      this.hubConnection = new HubConnectionBuilder()
        .withUrl(`${url}/chat?itemLevelId=` + itemLevelId, {
          accessTokenFactory: () => this.token,
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

      this.hubConnection
        .start()
        .catch((error) =>
          console.log('Error establishing the connection: ', error),
        );

      this.hubConnection.on('LoadComments', (comments: ChatComment[]) => {
        runInAction(() => {
          comments.forEach((comment) => {
            comment.createdAt = new Date(comment.createdAt + 'Z');
          });
          this.comments = comments;
        });
      });

      this.hubConnection.on('ReceiveComment', (comment: ChatComment) => {
        runInAction(() => {
          comment.createdAt = new Date(comment.createdAt);
          this.comments.unshift(comment);
        });
      });
    }
  };

  stopHubConnection = () => {
    this.hubConnection
      ?.stop()
      .catch((error) => console.log('Error stopping connection: ', error));
  };

  clearComments = () => {
    this.comments = [];
    this.stopHubConnection();
  };

  addComment = async (values: ValueComment) => {
    values.itemLevelId = store.activityStore.selectedActivity?.id;
    try {
      await this.hubConnection?.invoke('SendComment', values);
    } catch (error) {
      console.log(error);
    }
  };
}
